let mutationObserver;

function getTopFiveDeals() {
  const deals = getCardsContainer().querySelectorAll(
    '.cui-c-udc:not(.cui-c-navigation):not(.cui-c-collection)'
  );
  const ids = [];
  for (let i = 0; i < deals.length && i < 5; i++) {
    const bhc = deals[i].dataset.bhc;
    if (bhc) {
      const id = bhc.split(':')[1];
      if (ids.length < 5 && ids.indexOf(id) < 0) {
        ids.push(id);
      }
    }
  }
  return ids;
}

function getCardsContainer() {
  if (
    window.Groupon.PageFlags.isTouch &&
    (window.location.href.indexOf('browse') > 0 ||
      window.location.href.indexOf('goods') > 0)
  ) {
    return document.getElementById('pull-mobile-cards');
  }
  if (
    window.location.href.indexOf('browse') > 0 ||
    window.location.href.indexOf('goods') > 0
  ) {
    return document.getElementById('pull-deal-feed');
  }
  return document.getElementById('main-feed');
}

function updateGtmDataTopFiveDeals() {
  const deals = getTopFiveDeals();

  const data = window.gtmData ? window.gtmData.data : null;
  if (deals.length >= 5 && data) {
    const gtmData = JSON.parse(window.gtmData.data.replace(/&quot;/g, '"'));
    gtmData.dl_deal_uuids = deals;

    window.gtmData.data = JSON.stringify(gtmData);
    if (window.dataLayer) {
      window.dataLayer.push({ dl_deal_uuids: deals });
    }

    mutationObserver.disconnect();
  }
}

function manageUpdateGtmDataTopFiveDeals() {
  mutationObserver = new MutationObserver(updateGtmDataTopFiveDeals);
  const options = {
    childList: true,
    subtree: true,
  };
  const cardsContainer = getCardsContainer();
  if (cardsContainer) {
    mutationObserver.observe(cardsContainer, options);
  }
}

module.exports = {
  manageUpdateGtmDataTopFiveDeals,
};
